import { render, staticRenderFns } from "./DataImports.vue?vue&type=template&id=77032c21"
import script from "./DataImports.vue?vue&type=script&lang=js"
export * from "./DataImports.vue?vue&type=script&lang=js"
import style0 from "./DataImports.vue?vue&type=style&index=0&id=77032c21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports